/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChooseSource/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelectOneWithLabelField from 'DesignSystem/TysiaSelectOneWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function ChooseSource({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Initial/SettingsAction/ChooseSource",
  onChange
  
}) {
let sourcesDevicesValueData = fromData.useDataValue({ viewPath,
context: 'sources',
path: 'devices',
})
let recorderDeviceIdValueData = fromData.useDataValue({ viewPath,
context: 'recorder',
path: 'deviceId',
})
let recorderDeviceIdChangeData = fromData.useDataChange({ viewPath,
context: 'recorder',
path: 'deviceId',
})
  return (<React.Fragment
>
<TysiaSelectOneWithLabelField
  viewPath={`${viewPath}/TysiaSelectOneWithLabelField`}
 size="small"
 marginTop={0.1}
 data="sources.devices"
 from={sourcesDevicesValueData}
 data="recorder.deviceId"
 value={recorderDeviceIdValueData}
 onChange={recorderDeviceIdChangeData}
 label="Microphone"
/>
{children}
</React.Fragment>)
}